import {DropdownMenu} from 'letrus-ui';
import {useNavigate} from 'react-router-dom';
import './Menu.scss';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import {useLogout} from 'APIs/letrusAPI/logout';
import {ItemProps} from 'letrus-ui/dist/components/ui/DropdownMenu';

const MATO_GROSSO_SCHOOL_NETWORK_IDS = [80, 115, 124];

interface MenuProps {
  onLogoutClick?: () => void;
}

function Menu({onLogoutClick}: MenuProps): JSX.Element {
  const logout = useLogout();
  const navigate = useNavigate();
  const isOnLayers = !!window.sessionStorage.getItem('LayersPlatform');

  const {userRole} = getUserData();

  function getMenuItems(): ItemProps[] {
    const logOut: ItemProps = {
      id: 3,
      text: 'Sair',
      icon: 'sign-out-alt',
      onClick: onLogoutClick ?? (() => logout.trigger()),
    };

    const studentHomePage: ItemProps = {
      id: 1,
      text: 'Pagina Inicial',
      icon: 'home',
      onClick: () => {
        navigate('/');
      },
    };

    const studentProfilePage: ItemProps = {
      id: 2,
      text: 'Perfil',
      icon: 'user',
      onClick: () => {
        navigate('/perfil');
      },
    };

    const studentLibrary: ItemProps = {
      id: 4,
      text: 'Biblioteca',
      icon: 'book-open',
      onClick: () => {
        navigate('/biblioteca');
      },
    };

    const shouldShowLibraryOnMenu = MATO_GROSSO_SCHOOL_NETWORK_IDS.includes(
      Number(userRole?.school_network_id),
    );

    return [
      studentHomePage,
      studentProfilePage,
      ...(shouldShowLibraryOnMenu ? [studentLibrary] : []),
      ...(isOnLayers ? [] : [logOut]),
    ];
  }

  return (
    <div className="Menu" data-testid="Menu">
      <div className="Dropdown">
        <DropdownMenu title="Ir para" items={getMenuItems()} />
      </div>
    </div>
  );
}

export default Menu;
